import {Injectable} from '@angular/core';
import {ConversionResidents} from './ConversionResidents';

@Injectable({
  providedIn: 'root'
})
export class SelectedSessionDetails {
  enteredSessionId: string;
  selectedCorpId: string;
  selectedCorpText: string;
  selectedFacId: string;
  selectedFacText: string;
  selectedEnvId: string;
  selectedEnvText: string;
  selectedUnits: any;
  selectedDocTypes: any;
  enteredDateRange: string;
  searchedResidents: ConversionResidents[] = [];
  selectedSourceUnitsCount: string;
  selectedSourceDocTypesCount: string;
  selectedResidentCount: number;
  sourceSessionObj: string;
  selectedResidentIds: string[] = [];
  checkAllToggleCheckbox: boolean;
}
